import { FC } from 'react';
import { Box, BoxProps, Text } from '@chakra-ui/react';
import { formatNumber } from '../../helpers';
export interface CbStatsCardProps extends BoxProps {
  progress: number;
  name: string;
}
export const CbStatsCard: FC<CbStatsCardProps> = ({
  progress,
  name,
  ...props
}) => {
  return <Box backgroundColor="darkMode.500" border="1px solid" borderColor="rgba(255, 255, 255, 0.2)" borderRadius={24} boxShadow="standardCard" color="text.primaryWhite" paddingX={{
    base: 4,
    lg: 6
  }} paddingTop={1} paddingBottom="14px" {...props} data-sentry-element="Box" data-sentry-component="CbStatsCard" data-sentry-source-file="CbStatsCard.tsx">
      <Text fontSize="sm" fontWeight="semibold" data-sentry-element="Text" data-sentry-source-file="CbStatsCard.tsx">
        {name}
      </Text>
      <Text fontFamily="codenext" fontSize="2xl" marginBottom="2px" data-sentry-element="Text" data-sentry-source-file="CbStatsCard.tsx">
        {formatNumber(progress)}
      </Text>
    </Box>;
};